import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { generateQueryParams } from "helpers/queryParams";
import convertDateFormat from "Components/Date/DateFormat";
import { getForms, updateFormStatus } from "helpers/API Calls/System & Settings/Customar Forms";
import UpdateModal from "./UpdateModal";

const head = [
  { id: 0, name: "#", isSortable: true, key: "id" },
  { id: 2, name: "Callback Time", isSortable: true, key: "callback_time" },
  { id: 1, name: "Name", isSortable: true, key: "name" },
  { id: 3, name: "Phone", isSortable: false, key: "phone_no" },
  { id: 5, name: "Status", isSortable: true, key: "status" },
  { id: 7, name: "Created", isSortable: true, key: "created_at" },
  { id: 8, name: "Updated", isSortable: true, key: "updated_at" },
  { id: 9, name: "Actions", isSortable: false, key: "actions" }
];

function Callback() {  
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});
  
    const [editModal, setEditModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    
    const { filters, updateFilter } = useTableFilters();
  
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getForms(generateQueryParams(filters) + "&type=callback");
      if (response.success) {
        setData(response.data.items);
        setPagination(response.data.pagination);
      }
      setIsLoading(false);
    }
  
    useEffect(() => {
      fetchData();
    }, [filters]);
  
    const handleEditClick = (item) => {
      setSelectedItem(item);
      setEditModal(true);
    };


    const handleEditConfirm = async (note: string, status: number) => {
      if (selectedItem) {
        const reqData : {notes?: string, status?: number} = {};
        if (note) reqData.notes = note;
        if(status === 0 || status === 1) reqData.status = status;
        const response = await updateFormStatus(selectedItem.id, reqData);
        if (response.success) {
          setEditModal(false);
          setSelectedItem(null);
          fetchData();
        }
      }
    };
  
    const onCloseClick = () => {
      setEditModal(false);
      setSelectedItem(null);
    };
  
  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: 'Customer Callbacks' }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              > 
              {data.length > 0 && data.map((item) => (                
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item?.content?.callback_time}</td>
                  <td className="text-truncate">{item?.content?.name}</td>
                  <td>{item?.content?.phone_no}</td>
                  <td>
                    <span className={`badge badge-soft-${item.status === 1 ? 'success' : 'danger'}`}>
                      {item.status === 1 ? 'Done' : 'Pending'}
                    </span>
                  </td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <button className="btn btn-primary btn-sm" onClick={() => handleEditClick(item)}><i className="bx bx-pencil"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {editModal &&
    <UpdateModal
      title={`Update Callback - ${selectedItem?.content?.name}`}
      options={[
        { value: 1, label: 'Done' },
        { value: 0, label: 'Pending' }
      ]}
      onClose={onCloseClick}
      onSave={handleEditConfirm}
      user_note={selectedItem?.content?.notes || ""}
      status={selectedItem?.status}
    />}
    </>
  );
}

export default Callback;
